const updates = [
  { date: '2026-07-29', title: '《斗罗大陆》第358话更新：海神九考终极试炼开启', tag: '最新' },
  { date: '2026-07-29', title: '《完美世界》第412话：石昊对决禁区之主巅峰之战', tag: '热门' },
  { date: '2026-07-28', title: '《斗破苍穹》第607话：萧炎炼化异火突破斗尊', tag: '推荐' },
  { date: '2026-07-28', title: '新作《星域剑神》上线：星际修真题材强势来袭', tag: '新番' },
  { date: '2026-07-27', title: '《一人之下》第523话：无根生真实身份浮出水面', tag: '热议' },
  { date: '2026-07-27', title: '《狐妖小红娘》番外篇更新：涂山红红前世回忆', tag: '精品' },
  { date: '2026-07-26', title: '《镇魂街》第311话：曹焱兵新守护灵觉醒', tag: '更新' },
  { date: '2026-07-26', title: '《全职高手》特别篇：叶修与一叶之秋的宿命对决', tag: '特别' },
  { date: '2026-07-25', title: '平台公告：漫画阅读器升级，翻页速度提升30%', tag: '公告' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-5xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            更新动态
          </h2>
          <p className="text-sm text-foreground-500">51漫画网最新连载与平台资讯速递</p>
        </div>
        <div className="relative">
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-background-300"></div>
          <div className="space-y-5">
            {updates.map((item) => (
              <div key={`${item.date}-${item.title}`} className="relative flex items-start gap-4 md:gap-6 pl-10 md:pl-14">
                <div className="absolute left-[10px] md:left-[18px] w-2.5 h-2.5 rounded-full bg-primary-500 border-2 border-background-50 mt-1.5 z-10"></div>
                <div className="flex-1 bg-background-100 rounded-xl p-4 hover:bg-background-100 transition-colors cursor-pointer">
                  <div className="flex items-center gap-2 flex-wrap mb-1">
                    <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                    <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100/70 text-accent-700 font-medium whitespace-nowrap">{item.tag}</span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}